import { DataList, Link, Badge } from '@radix-ui/themes';
import { getBlogAddress } from '../../utils/PageAddressUtil';

export default function BlogRequestTable({
    name, description, domainName, address, rssAddress, adminEmail,
    requestedAt, updatedAt, approved, failed, status, statusInfo, reason,
}) {
    const blogAddress = approved ? getBlogAddress(domainName) : address;

    return (
        <div className="redesign-detail-panel">
            <header className="redesign-page-header" style={{ marginBottom: 20 }}>
                <h1 className="redesign-page-title">博客「{name || '…'}」审核详情</h1>
            </header>
            <DataList.Root>
                <DataList.Item>
                    <DataList.Label minWidth="88px">博客名称</DataList.Label>
                    <DataList.Value><Link target="_blank" href={address}>{name}</Link></DataList.Value>
                </DataList.Item>
                <DataList.Item>
                    <DataList.Label minWidth="88px">博客描述</DataList.Label>
                    <DataList.Value>{description}</DataList.Value>
                </DataList.Item>
                <DataList.Item>
                    <DataList.Label minWidth="88px">RSS 地址</DataList.Label>
                    <DataList.Value>
                        <Link target="_blank" href={rssAddress}>{rssAddress}</Link>
                    </DataList.Value>
                </DataList.Item>
                <DataList.Item>
                    <DataList.Label minWidth="88px">博主邮箱</DataList.Label>
                    <DataList.Value>{adminEmail}</DataList.Value>
                </DataList.Item>
                <DataList.Item>
                    <DataList.Label minWidth="88px">提交时间</DataList.Label>
                    <DataList.Value>{requestedAt}</DataList.Value>
                </DataList.Item>
                <DataList.Item>
                    <DataList.Label minWidth="88px">审核状态</DataList.Label>
                    <DataList.Value>
                        <Link href={blogAddress}>
                            <Badge
                                size="2"
                                className={approved ? 'redesign-badge-pass' : ''}
                                color={approved ? 'green' : (failed ? 'crimson' : 'orange')}
                            >
                                {statusInfo}
                            </Badge>
                        </Link>
                    </DataList.Value>
                </DataList.Item>
                {('approved' === status || 'rejected' === status || 'uncollected' === status) && (
                    <DataList.Item>
                        <DataList.Label minWidth="88px">审核时间</DataList.Label>
                        <DataList.Value>{updatedAt}</DataList.Value>
                    </DataList.Item>
                )}
                {('rejected' === status || 'uncollected' === status) && (
                    <DataList.Item>
                        <DataList.Label minWidth="88px">驳回原因</DataList.Label>
                        <DataList.Value>{reason}</DataList.Value>
                    </DataList.Item>
                )}
            </DataList.Root>
        </div>
    );
}
